<div class="sk-cms-video sk-cms-video-wap {{isPreview ? '': 'sk-component VIDEO'}}"
    {{if style.background.styleType != 'default'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>

    {{if style.isShowTitle == '1'}}
        <% include('../common/title.art', {title: basic.title, terminal: 'title-wap'}) %>
    {{/if}}

    {{if !content.items || !content.items.length}}
         <% include('../common/nodata.art') %>
    {{else}}
    {{if style.moreStyle.styleType != 'hide' && isMain != 1}}
    <div class="sk-cms-more-wap">

            <div class="more sk-cms-more-dom">
                {{if isDesign}}
                    <span class="more-btn {{style.moreStyle.styleType == 'default'?'medium':style.moreStyle.fontSize}}" style="{{style.moreStyle.styleType == 'default' ? '': 'color:' + style.moreStyle.color}}">MORE >></span>
                {{else}}
                    <a class="more-btn goto-link {{style.moreStyle.styleType == 'default'?'medium':style.moreStyle.fontSize}}" style="{{style.moreStyle.styleType == 'default' ? '': 'color:' + style.moreStyle.color}}" href="{{isPreview ? content.moreLink: content.morePage}}">MORE >></a>
                {{/if}}
            </div>

    </div>
{{/if}}
    <div class="video-main {{basic.style.type}} {{basic.columns.type}}">
    {{each content.items}}
        <div class="video-items {{style.lineStyle.model === 'custom' ? style.lineStyle.line : ''}} {{style.lineStyle.model === 'hide' ? 'hide': ''}}"
            {{if style.lineStyle.model === 'custom'}}
            style="border-color: {{style.lineStyle.color}}"
            {{/if}}>
            <div class="video-box">
                <div class="video-picture">
                    <div class="video-img">
                    {{if $value.linkType === 'custom' && $value.link}}
                        <a class="goto-link" href="{{$value.link}}" target="blank">
                        <img src="{{$value.imgUrl? $value.imgUrl: '../../assets/images/img_default.jpg'}}" alt="" cms-smarket>
                        </a>
                    {{else}}
                        <img src="{{$value.imgUrl? $value.imgUrl: '../../assets/images/img_default.jpg'}}" alt="" cms-smarket>
                        {{/if}}
                    </div>
                    {{if $value.linkType === 'video'}}
                    <div class="video-play" sk-event.click='showPlay({{$value}})' cms-value-raw>
                        <img src="{{'../../assets/images/play-i.png'}}" alt="" cms-smarket>
                    </div>
                    {{/if}}
                </div>
                {{if style.titleStyle.styleType !== 'hide' || style.timeStyle.styleType !== 'hide'}}
                <div class="video-info">
                    {{if style.titleStyle.styleType !== 'hide'}}
                    <div class="video-title {{style.titleStyle.styleType === 'custom' ? style.titleStyle.fontSize : ''}}"
                         style="{{style.titleStyle.styleType === 'custom' ? ('color:' + style.titleStyle.color) : ''}}">
                        {{if $value.linkType === 'custom' && $value.link}}
                        <a class="goto-link" href="{{$value.link}}" target="blank">
                        {{$value.title}}
                        </a>
                        {{else}}
                        {{$value.title}}
                        {{/if}}
                    </div>
                    {{/if}}
                    {{if style.timeStyle.styleType !== 'hide'}}
                    <div class="video-time {{style.timeStyle && style.timeStyle.styleType === 'custom' ? style.timeStyle.fontSize : ''}}"
                         style="{{style.timeStyle && style.timeStyle.styleType === 'custom' ? ('color:' + style.timeStyle.color) : ''}}">
                        {{$value.pushTime ? $value.pushTime : ''}}
                    </div>
                    {{/if}}
                </div>
                {{/if}}
            </div>
        </div>
    {{/each}}
    </div>
    {{/if}}
    {{if !isDesign}}
    <article class="sk-video-iframe sk-video-iframe-wap" sk-if="$data.isShowVideo">
        <div class="vf-back" sk-event.click="hidePlay()"></div>
        <div class="vf-main">
            <div class="vf-iframe" sk-html="$data.code"></div>
            <div class="vf-bottom">
                <div class="vf-title" sk-text="$data.title"></div>
                <div class="vf-time" sk-text="$data.pushTime"></div>
            </div>
        </div>
    </article>
    {{/if}}
    {{if isMain == 1}}
        <% include('../common/pagination.art') %>
    {{/if}}
</div>

